const EXT_TO_MIME = {
  pdf: 'application/pdf',
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
};

export function buildAccept(allowedTypes) {
  return allowedTypes.reduce((acc, ext) => {
    const mime = EXT_TO_MIME[ext];
    if (mime) acc[mime] = [...(acc[mime] || []), `.${ext}`];
    return acc;
  }, {});
}

export function getFileExtension(filename) {
  const parts = filename.split('.');
  if (parts.length > 1) {
    return parts.pop()?.toLowerCase() || null;
  }
  return null;
}

export function getFileSize(fileOrBytes) {
  const bytes = typeof fileOrBytes === 'number' ? fileOrBytes : fileOrBytes.size;

  if (!bytes) return '0 B';

  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  const value = bytes / Math.pow(1024, i);

  return `${value.toFixed(2)} ${sizes[i]}`;
}